module.exports = __webpack_public_path__ + "img/3x3basketball.ce107d26.svg";